import { CustomerOrder } from "src/interfaces/order.interface";

const EMPTY_LABEL = "Not provided";

function valueOrEmpty(val: string | null | undefined): string {
  if (val == null || val === "" || String(val).toLowerCase() === "null") return EMPTY_LABEL;
  return String(val);
}

interface CustomerDetailsProps {
  customerOrder: CustomerOrder;
  /** Tighter spacing and panel typography when used inside drawer */
  compact?: boolean;
}

const CustomerDetails = ({ customerOrder, compact }: CustomerDetailsProps) => {
  const labelCls = compact ? "text-[14px] text-[#6B7280] w-[140px] shrink-0" : "text-[#666666] text-sm w-[200px]";
  const valueCls = compact ? "text-[14px] font-semibold text-[#111827]" : "text-[#1A1A1A] text-sm font-medium";
  const emptyCls = compact ? "text-[14px] text-[#9CA3AF]" : "text-sm text-[#9CA3AF]";
  const rowCls = compact ? "flex items-center min-h-[24px]" : "flex mt-3 items-center";
  const titleCls = compact ? "text-[14px] font-semibold text-[#111827] mb-2" : "text-base text-[#1A1A1A] font-bold mt-6";

  const val = (v: string | null | undefined) => valueOrEmpty(v);
  const isEmpty = (v: string | null | undefined) => val(v) === EMPTY_LABEL;

  return (
    <>
      <h2 className={titleCls}>Customer Details</h2>
      <div className={rowCls}>
        <span className={labelCls}>Email</span>
        <span className={isEmpty(customerOrder?.customerEmail) ? emptyCls : valueCls}>{val(customerOrder?.customerEmail)}</span>
      </div>
      <div className={rowCls}>
        <span className={labelCls}>First Name</span>
        <span className={isEmpty(customerOrder?.customerFirstName) ? emptyCls : valueCls}>{val(customerOrder?.customerFirstName)}</span>
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Last Name</span>
        <span className={isEmpty(customerOrder?.customerLastName) ? emptyCls : valueCls}>{val(customerOrder?.customerLastName)}</span>
      </div>
    </>
  );
};

export default CustomerDetails;
